<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/sendGooData')">发货统计</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >

          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>

          <el-form-item label="代理类型">
            <el-select clearable v-model="filters.roleType" placeholder="请选择">
                  <el-option label="董事" value="1"></el-option>
                  <el-option label="区域总监" value="2"></el-option>
                </el-select>
        </el-form-item>

        <el-form-item label='代理手机号'>
            <el-input
              v-model="filters.userphone"
              placeholder="代理手机号"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch()"
            >统计</el-button>

            <!-- <el-button
              type="primary"
              @click="showDetailInfos"
            >查看订单明细</el-button> -->
            <el-button
              type="primary"
              @click="excelOut(1)"
            >导出</el-button>
            <el-button
              type="primary"
              @click="excelOut(2)"
            >导出全部</el-button>
            <el-button
              style="margin-left:10px"
              @click="goDown"
              type="danger"
              size="small"
            >到底部</el-button>

            <el-button
              style="margin-left:10px"
              @click="goTop"
              type="warn"
              size="small"
            >到顶部</el-button>
            <el-button
              type="primary"
              @click="excelOutUserDistrict"
            >导出发货价值统计</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div>
        <el-table
          ref="dataTable"
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="goodName"
            label="商品名称"
          >
          </el-table-column>

          <el-table-column
            prop="noVip"
            label="是否耗材"
          >
          <template slot-scope="scope">
              <el-tag
                v-if="scope.row.noVip == 2"
                type="success"
                disable-transitions
              >是</el-tag>
              <el-tag
                v-if="scope.row.noVip == 1"
                type="info"
                disable-transitions
              >否</el-tag>
            </template>
        </el-table-column>

          <el-table-column
            prop="goodNum"
            label="数量"
          >
          </el-table-column>

          <el-table-column
            prop="topPrice"
            label="价格"
          >
          </el-table-column>
        </el-table>
      </div>

    </div>

    <el-dialog
      title="明细"
      :visible.sync="subListVisible"
      width="70%"
    >
      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
            prop="username"
            label="代理姓名"
          >
          </el-table-column>

          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="order_code"
            label="订单号"
          >
          </el-table-column>

          <el-table-column
            prop="send_name"
            label="发货人"
          >
          </el-table-column>

          <el-table-column
            prop="total_money"
            label="总金额"
          >
          </el-table-column>

          <el-table-column
            prop="score_price"
            label="总积分"
          >
          </el-table-column>
          <!-- :show-overflow-tooltip="true" -->
          <el-table-column
            prop="create_time"
            label="下单时间"
          >
          </el-table-column>

          <el-table-column
            prop="postage_status"
            label="包邮状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.postage_status == 1"
                type="success"
                disable-transitions
              >包邮</el-tag>
              <el-tag
                v-if="scope.row.postage_status == 2"
                type="info"
                disable-transitions
              >不包邮</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="postage_type"
            label="送货类型"
            width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.postage_type == 1"
                type="success"
                disable-transitions
              >自提</el-tag>
              <el-tag
                v-if="scope.row.postage_type == 2"
                type="success"
                disable-transitions
              >快递</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="province"
            label="地址信息 "
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{scope.row.add_name }} {{scope.row.add_tel }} {{scope.row.province }}{{scope.row.city }}{{scope.row.district }}{{scope.row.address_detail }}
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            label="订单详情"
          >
            <template slot-scope="scope">

              1
              <router-link
                target="_blank"
                :to="{path:'/orderDetail',query:{orderId:scope.row.id}}"
              >查看</router-link>
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            :formatter="formatterStatus"
            label="状态"
          >
          </el-table-column>

          <el-table-column
            prop="order_info"
            label="订单备注"
          >
          </el-table-column>

          <el-table-column
            prop="send_time1"
            label="发货时间"
            width="100"
          >
          </el-table-column>

      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page_num"
          :page-count='total_page'
          :page-size="page_size"
          layout="total, prev, pager, next"
          :total="total_num"
        >
        </el-pagination>
      </div>

    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
import { re } from "semver";
var _ = require("lodash");
export default {
  name: "userInData",
  created() {},
  data() {
    return {
      totalMoney: 0,
      userList:[],
      subListVisible: false,
      listLoading: false,
      picList: [],
      askRoleType: null,
      filters: {
        roleType:null,
        startTime: null,
        endTime: null,
        userphone: null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailListLoading: false,
      tableDetailData: [],
      tableHeight: null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    let that = this;
      let para = {
        token: localStorage.getItem("api_token")
      };
      API.top_user_list(para)
        .then(
          function(result) {
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                that.userList = result.result.list;
              } else {
                that.userList = [];
              }
            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });

  },
  methods: {
    formatterStatus(row, column) {
      if (row.status == 1) {
        return "待支付";
      } else if (row.status == 2) {
        return "待发货";
      } else if (row.status == 3) {
        return "待收货";
      } else if (row.status == 4) {
        return "已完成";
      } else if (row.status == 5) {
        return "已取消";
      } else if (row.status == 7) {
        return "待自提";
      } else if (row.status == 8) {
        return "已自提";
      } else if (row.status == 9) {
        return "待补货";
      } else if (row.status == 10) {
        return "补货待支付";
      } else if (row.status == 11) {
        return "补货已完成";
      } else if (row.status == 12) {
        if (row.expire_type == null) {
          return "补货已过期";
        } else {
          if (row.expire_type == 1) {
            return "超时未支付过期";
          } else if (row.expire_type == 2) {
            return "超时未补货过期";
          }
        }
      }
    },
    goDown(){
      this.$refs.dataTable.bodyWrapper.scrollTop =this.$refs.dataTable.bodyWrapper.scrollHeight;
    },
    goTop(){
      this.$refs.dataTable.bodyWrapper.scrollTop =0;
    },
    showDetailInfos(row) {
      if (!this.filters.endTime || this.filters.endTime == null || !this.filters.startTime || this.filters.startTime == null || !this.filters.userId || this.filters.userId == null)
      {
        this.$message.error({
            showClose: true,
            message: "请检查下时间或者总经销商是否都已经选择好",
            duration: 2000
          });
      } else
      {
        let that = this;
        that.subListVisible = true;
        this.page_size = 10;
        this.page_num = 1;
        this.searchDetail();
      }

    },
    searchDetail() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        orderType: 1,
        status: 22,//查询已自提+发货已完成的
        pageNum: that.page_num,
        pageSize: that.page_size
      };
      if (that.filters.startTime) {
        para.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        para.endTime = that.filters.endTime.getTime();
      }
      that.detailListLoading = true;
      API.order_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num = result.result.count;
            that.total_page = result.result.allPageNumber;


              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  if (result.result.list[i].send_time != null)
                  {
                    result.result.list[i].send_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].send_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  }
                }
              }
              that.tableDetailData = result.result.list;
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    excelOutUserDistrict(){
      var that = this;
      var url =
        "/manager/user/pc/app_user_District_balance_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&beginTime=" + that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择代理类型",
            duration: 2000
          });
        return;
      }
      top.location.href = url;
    },
    excelOut(type) {
      var that = this;
      var url =
        "/manager/user/pc/send_head_num_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (type == 1) {
        if (that.filters.roleType != null) {
        if(that.filters.userphone){
        } else{
        that.$message.error({
            showClose: true,
            message: "输入手机号",
            duration: 2000
          });
        return;
      }
    }
    if (that.filters.userphone != null) {
        if(that.filters.roleType){
        } else{
        that.$message.error({
            showClose: true,
            message: "选择代理类型",
            duration: 2000
          });
        return;
      }
  }
    url = url + "&roleType=" + that.filters.roleType;
    url = url + "&userPhone=" + that.filters.userphone;
    url = url + "&type=" + 2
    }else{
    if (that.filters.roleType) {
      } else {
          that.$message.error({
            showClose: true,
            message: "请选择代理类型",
            duration: 2000
          });
        return;
      }
      url = url + "&roleType=" + that.filters.roleType;
      url = url + "&type=" + 1
    }
      top.location.href = url;
    },
    handleSearch() {
      this.search();
    },
    formatterRoleType(row, column) {
      if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == -0.5) {
        return "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        return "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        return "康减系列荣誉会员";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      }  else if (row.role_type == 4.8) {
        return "经销商";
      }
    },

    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        type: 3
      };
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }

      if (that.filters.roleType != null) {
        if(that.filters.userphone){
        params.roleType = that.filters.roleType;
        params.userPhone = that.filters.userphone;
        } else{
        that.$message.error({
            showClose: true,
            message: "输入手机号",
            duration: 2000
          });
        return;
      }
    }

    if (that.filters.userphone != null) {
        if(that.filters.roleType){
        params.roleType = that.filters.roleType;
        params.userPhone = that.filters.userphone;
        } else{
        that.$message.error({
            showClose: true,
            message: "选择代理类型",
            duration: 2000
          });
        return;
      }
    }
      that.listLoading = true;
      API.send_head_num(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                that.tableData = result.result.list;
                that.totalMoney = result.result.map.totalM;
              } else {
                that.tableData = [];
              }
              console.info(that.tableData)
            }else if(result.key == 0){
              that.$message.error({
              showClose: true,
              message: result.message,
              duration: 2000
          });
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.searchDetail(this.askRoleType);
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/sendGooData.vue